export const frontendVersion = 'Last Frontend build 2024-07-01T10:52:12+00:00 [6bc5a6a6858838d03c9a4bbd7514fdf01171b4ab]'
